// extracted by mini-css-extract-plugin
export const wrapper = "downloads-module--wrapper--IY2Ba";
export const container = "downloads-module--container--3E_W3";
export const download = "downloads-module--download--HHzGt";